// extracted by mini-css-extract-plugin
module.exports = {"offeringPlan":"style_offeringPlan__3DRME"};